import * as React from 'react';

import Loading from './Loading';

interface BrokerageLogoProps {
  logoUrl: string;
  height?: number;
  width?: number;
  fallbackURL?: string;
}

interface BrokerageLogoState {
  image: HTMLImageElement;
  loading: boolean;
}

class BrokerageLogo extends React.Component<
  BrokerageLogoProps,
  BrokerageLogoState
> {
  constructor(props: BrokerageLogoProps) {
    super(props);
    this.state = {
      image: new Image(),
      loading: true,
    };
  }

  public componentDidMount() {
    const { image } = this.state;

    image.src = this.props.logoUrl;

    image.onload = () => {
      this.setState({ loading: false });
    };

    image.onerror = () => {
      image.src = this.FALLBACK_URL;
      image.classList.add('fallback-image');
    };
  }

  private FALLBACK_URL =
    this.props.fallbackURL ||
    `https://cdn.filestackcontent.com/YdPWdNsTkCoO7xyuaEQj`;

  public render() {
    const { image, loading } = this.state;
    const { height, width } = this.props;
    return loading ? (
      <Loading noPadding />
    ) : (
      <img
        src={image.src}
        style={{
          maxHeight: `${height}px`,
          maxWidth: `${width}px`,
        }}
        className={`brokerage-logo ${image.className}`}
      />
    );
  }
}

export default BrokerageLogo;
